// extracted by mini-css-extract-plugin
export default {"wrapper":"Brand_wrapper__gp8wv","title":"Brand_title__mratW","marquee":"Brand_marquee__SEVLR","track":"Brand_track__0q9hj","scroll":"Brand_scroll__XrBFq","logo":"Brand_logo__3gIAx"};